import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {AdminBannerDefaultBox} from "./admin-banner-wrapper.default.box";
import {AdminBannerSIBox} from "./admin-banner-wrapper.si.box";


export const AdminBannerBox = styledByTheme(AdminBannerDefaultBox)
    .forSI(AdminBannerSIBox)
    .apply();